import { dateService, FORMATS } from '@/global/services/date'
import { getBooleanFromValue } from '@/global/utils/utils'

export default {
  name: 'Details',

  computed: {
    detailsEditConfig () {
      return {
        title: this.$t('fleet/activity.vehicle_details'),
        key: 'details',
        formData: this.formData?.item,
        onTabChange: () => {
          this.showMainEditButtons = true
        },
        editUpdate: (event) => {
          const { edit } = event || {}
          this.$set(this.disableTabs, 'canBus', edit)
          this.$set(this.disableTabs, 'readouts', edit)
          this.$set(this.disableTabs, 'documents', edit)
          this.$set(this.disableTabs, 'inspections', edit)
          this.$set(this.disableTabs, 'insurances', edit)
          this.$set(this.disableTabs, 'leasing', edit)
          this.$set(this.disableTabs, 'rangeLimits', edit)
          this.$set(this.disableTabs, 'serviceIntervals', edit)
          this.$set(this.disableTabs, 'serviceHistory', edit)
          this.$set(this.disableTabs, 'comments', edit)
          this.$set(this.disableTabs, 'damages', edit)
        },
        tabContent: [
          {
            title: this.$t('fleet/activity.vehicle_details'),
            component: this.columnsContentComponent,
            rows: [
              {
                disabled: !getBooleanFromValue(this.permissions?.canEdit),
                columnsCount: 4,
                fields: [
                  {
                    key: 'number_of_seats',
                    label: this.$t('fleet/vehicle_attribute.number_of_seats'),
                    field_type: 'number',
                    creatable: this.viewConfig?.editable_fields?.includes('number_of_seats'),
                    visible: this.viewConfig?.editable_fields?.includes('number_of_seats'),
                    editable: this.viewConfig?.editable_fields?.includes('number_of_seats')
                  },
                  {
                    key: 'engine_ccm',
                    label: this.$t('fleet/vehicle_attribute.engine_ccm'),
                    field_type: 'number',
                    creatable: this.viewConfig?.editable_fields?.includes('engine_ccm'),
                    visible: this.viewConfig?.editable_fields?.includes('engine_ccm'),
                    editable: this.viewConfig?.editable_fields?.includes('engine_ccm')
                  },
                  {
                    key: 'engine_power',
                    label: this.$t('fleet/vehicle_attribute.engine_power'),
                    field_type: 'number',
                    creatable: this.viewConfig?.editable_fields?.includes('engine_power'),
                    visible: this.viewConfig?.editable_fields?.includes('engine_power'),
                    editable: this.viewConfig?.editable_fields?.includes('engine_power')
                  },
                  {
                    key: 'co2_emission',
                    label: this.$t('fleet/vehicle_attribute.co2_emission'),
                    creatable: this.viewConfig?.editable_fields?.includes('co2_emission'),
                    visible: this.viewConfig?.editable_fields?.includes('co2_emission'),
                    editable: this.viewConfig?.editable_fields?.includes('co2_emission')
                  },
                  {
                    key: 'euro_standard',
                    label: this.$t('fleet/vehicle_attribute.euro_standard'),
                    type: 'text',
                    creatable: this.viewConfig?.editable_fields?.includes('euro_standard'),
                    visible: this.viewConfig?.editable_fields?.includes('euro_standard'),
                    editable: this.viewConfig?.editable_fields?.includes('euro_standard')
                  },
                  {
                    key: 'battery_voltage',
                    label: this.$t('fleet/vehicle_attribute.battery_voltage'),
                    type: 'text',
                    creatable: this.viewConfig?.editable_fields?.includes('battery_voltage'),
                    visible: this.viewConfig?.editable_fields?.includes('battery_voltage'),
                    editable: this.viewConfig?.editable_fields?.includes('battery_voltage')
                  },
                  {
                    key: 'oil_type',
                    label: this.$t('fleet/vehicle_attribute.oil_type'),
                    creatable: this.viewConfig?.editable_fields?.includes('oil_type'),
                    visible: this.viewConfig?.editable_fields?.includes('oil_type'),
                    editable: this.viewConfig?.editable_fields?.includes('oil_type')
                  },
                  {
                    key: 'antifreeze_type',
                    label: this.$t('fleet/vehicle_attribute.antifreeze_type'),
                    creatable: this.viewConfig?.editable_fields?.includes('antifreeze_type'),
                    visible: this.viewConfig?.editable_fields?.includes('antifreeze_type'),
                    editable: this.viewConfig?.editable_fields?.includes('antifreeze_type')
                  },
                  {
                    key: 'tire_size',
                    label: this.$t('fleet/vehicle_attribute.tire_size'),
                    creatable: this.viewConfig?.editable_fields?.includes('tire_size'),
                    visible: this.viewConfig?.editable_fields?.includes('tire_size'),
                    editable: this.viewConfig?.editable_fields?.includes('tire_size')
                  },
                  {
                    key: 'manufacture_year',
                    label: this.$t('fleet/vehicle_attribute.manufacture_year'),
                    field_type: 'number',
                    creatable: this.viewConfig?.editable_fields?.includes('manufacture_year'),
                    visible: this.viewConfig?.editable_fields?.includes('manufacture_year'),
                    editable: this.viewConfig?.editable_fields?.includes('manufacture_year')
                  },
                  {
                    key: 'vin',
                    label: this.$t('fleet/vehicle_attribute.vin'),
                    creatable: this.viewConfig?.editable_fields?.includes('vin'),
                    visible: this.viewConfig?.editable_fields?.includes('vin'),
                    editable: this.viewConfig?.editable_fields?.includes('vin')
                  },
                  {
                    key: 'empty_weight',
                    label: this.$t('fleet/vehicle_attribute.empty_weight'),
                    field_type: 'number',
                    creatable: this.viewConfig?.editable_fields?.includes('empty_weight'),
                    visible: this.viewConfig?.editable_fields?.includes('empty_weight'),
                    editable: this.viewConfig?.editable_fields?.includes('empty_weight')
                  },
                  {
                    key: 'maximum_weight',
                    label: this.$t('fleet/vehicle_attribute.maximum_weight'),
                    field_type: 'number',
                    creatable: this.viewConfig?.editable_fields?.includes('maximum_weight'),
                    visible: this.viewConfig?.editable_fields?.includes('maximum_weight'),
                    editable: this.viewConfig?.editable_fields?.includes('maximum_weight')
                  },
                  {
                    key: 'load_capacity',
                    label: this.$t('fleet/vehicle_attribute.load_capacity'),
                    field_type: 'number',
                    creatable: this.viewConfig?.editable_fields?.includes('load_capacity'),
                    visible: this.viewConfig?.editable_fields?.includes('load_capacity'),
                    editable: this.viewConfig?.editable_fields?.includes('load_capacity')
                  },
                  {
                    key: 'top_speed',
                    label: this.$t('fleet/vehicle_attribute.top_speed'),
                    field_type: 'number',
                    creatable: this.viewConfig?.editable_fields?.includes('top_speed'),
                    visible: this.viewConfig?.editable_fields?.includes('top_speed'),
                    editable: this.viewConfig?.editable_fields?.includes('top_speed')
                  },
                  {
                    key: 'length',
                    label: this.$t('fleet/vehicle_attribute.length'),
                    field_type: 'number',
                    creatable: this.viewConfig?.editable_fields?.includes('length'),
                    visible: this.viewConfig?.editable_fields?.includes('length'),
                    editable: this.viewConfig?.editable_fields?.includes('length')
                  },
                  {
                    key: 'width',
                    label: this.$t('fleet/vehicle_attribute.width'),
                    field_type: 'number',
                    creatable: this.viewConfig?.editable_fields?.includes('width'),
                    visible: this.viewConfig?.editable_fields?.includes('width'),
                    editable: this.viewConfig?.editable_fields?.includes('width')
                  },
                  {
                    key: 'extinguisher_expiry',
                    label: this.$t('fleet/vehicle_attribute.extinguisher_expiry'),
                    type: 'datetime-picker',
                    subType: 'date',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.date,
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.date, true)) {
                        updateValidationErrors({
                          extinguisher_expiry: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                        })
                      }
                    },
                    creatable: this.viewConfig?.editable_fields?.includes('extinguisher_expiry'),
                    visible: this.viewConfig?.editable_fields?.includes('extinguisher_expiry'),
                    editable: this.viewConfig?.editable_fields?.includes('extinguisher_expiry')
                  },
                  {
                    key: 'stop_threshold',
                    label: this.$t('fleet/vehicle_attribute.stop_threshold'),
                    field_type: 'number',
                    creatable: this.viewConfig?.editable_fields?.includes('stop_threshold'),
                    visible: this.viewConfig?.editable_fields?.includes('stop_threshold'),
                    editable: this.viewConfig?.editable_fields?.includes('stop_threshold')
                  },
                  {
                    key: 'enc',
                    label: this.$t('fleet/vehicle_attribute.enc'),
                    creatable: this.viewConfig?.editable_fields?.includes('enc'),
                    visible: this.viewConfig?.editable_fields?.includes('enc'),
                    editable: this.viewConfig?.editable_fields?.includes('enc')
                  },
                  {
                    key: 'driver_auto_logout_timeout',
                    label: this.$t('fleet/vehicle_attribute.driver_auto_logout_timeout'),
                    field_type: 'number',
                    creatable: this.viewConfig?.editable_fields?.includes('driver_auto_logout_timeout'),
                    visible: this.viewConfig?.editable_fields?.includes('driver_auto_logout_timeout'),
                    editable: this.viewConfig?.editable_fields?.includes('driver_auto_logout_timeout')
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
